/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_Top_RatedInputs */

const en_directory_footer_link_top_rated = /** @type {(inputs: Directory_Footer_Link_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top rated`)
};

const zh_directory_footer_link_top_rated = /** @type {(inputs: Directory_Footer_Link_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高分好评`)
};

/**
* | output |
* | --- |
* | "Top rated" |
*
* @param {Directory_Footer_Link_Top_RatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_top_rated = /** @type {((inputs?: Directory_Footer_Link_Top_RatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_Top_RatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_top_rated(inputs)
	return zh_directory_footer_link_top_rated(inputs)
});
export { directory_footer_link_top_rated as "directory.footer.link_top_rated" }